import React from "react";
import { Paper, Box } from "@mui/material";
import ArrowTarget from "./ArrowTarget";

export default function TargetPaper({ score }) {
  return (
    <Paper
      elevation={3}
      sx={{
        width: 400,
        height: 150,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: 1,
      }}
    >
      <Box sx={{ width: "100%", height: "100%" }}>
        <ArrowTarget score={score} />
      </Box>
    </Paper>
  );
}